export const FLAG_NAMES = {
  // Onboarding & Authentication
  ONBOARDING_V2: 'aip-436_onboarding_v.2',
  ONBOARDING_V2_ALT: 'aip-511_onboarding_v.2',
  LOGIN_WITH_CODE: 'aip-490_login',

  // Homepage & Layout
  HOMEPAGE_V2: 'aip-484_homepage-main-screen-and-layout-v2',
  HOME_TOP_RIGHT_USER_MENU: 'quintace_home_top_right_user_menu',
  HOME_AI_HOST_CHAT_NO_ACTION: 'quintace_home_ai_host_chat_no_action',

  SHOW_STUDY_MODE_ON_HOMEPAGE: 'aip-559_show-study-mode-on-homepage',

  // Game Modes
  STUDY_MODE: 'quintace_study_mode',

  // Chat & Communication
  USER_CHAT_ONLY: 'quintace_user_user_chat_only',
  COMMENTATOR_MODE: 'quintace_commentator_mode',
  // New user chat v2 toggle
  USER_CHAT_V2: 'aip-915_user-chat_v2'
} as const

export type FeatureFlagName = (typeof FLAG_NAMES)[keyof typeof FLAG_NAMES]
